import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'

interface downloadTemplateProps {
  setShowOverlay: Function
}

const downloadTemplate = async (props: downloadTemplateProps) => {
  let response: any = false

  response = await axiosGet(
    apiUrls.filterValuesToPermissions + '/' + apiUrls.actionTemplate,
    {},
    props.setShowOverlay,
    {
      responseType: 'blob',
    },
  ).then(async (response) => {
    if (response === undefined) {
      return
    }
    if (response.status === 200) {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data)
      // create "a" HTML element with href to file & click
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'Import Template.csv') //or any other extension
      document.body.appendChild(link)
      link.click()

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    }
    return response
  })

  return response
}

export default downloadTemplate
